import { type AssertionCondition, type SessionLog } from "@/utils/types";

const ASSERTION_CONDITION_LINE = /^Asserting: (.+) \((True|False)\)$/;

export const isAssertionStep = (log: SessionLog): boolean =>
  typeof log.prompt === "string" && log.prompt.trim().startsWith("Assert:");

export const parseAssertionConditions = (
  log: SessionLog
): AssertionCondition[] =>
  (log.gptCommands ?? []).reduce<AssertionCondition[]>((acc, line) => {
    const match = line.match(ASSERTION_CONDITION_LINE);
    if (match) acc.push({ condition: match[1], result: match[2] === "True" });
    return acc;
  }, []);

/**
 * A step whose false conditions did NOT fail the run: the test asked for the
 * verdicts and decided for itself (`checkBulk`, not `assert`).
 *
 * Only true when the SDK said so. A step from an older SDK reports no mode at
 * all, and guessing "assert" for those would report failures nobody suffered.
 */
export const isCheckStep = (log: SessionLog): boolean =>
  log.assertionMode === "check";
